import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Modal, SessionExpired } from "../../../common";
import { ReactComponent as PurchaseCompany } from "../../../../assets/icons/PurchaseCompany.svg";

import { useDispatch, useSelector } from "react-redux";
import { useGetUserPurchaedDataQuery } from "../../../../store/Company/companyApiSlice";
import { PurchaseList } from "../../../common/PurchaseList";
import { clearUserInfo } from "../../../../store/auth/authSlice";

export const PurchasedCompany = () => {
  const navigate = useNavigate();
  const { userInfo, token } = useSelector((state) => state.auth);
  const [isSessionExpired, setSessionExpired] = useState(false);
  const dispatch = useDispatch();
  const { data, isError, error } = useGetUserPurchaedDataQuery({
    token: token,
    id: userInfo?.individual[0]?.userID,
  });
  const sessionExpiredPopup = () => {
    setSessionExpired(!isSessionExpired);
    dispatch(clearUserInfo());
    navigate("/login");
  };
  useEffect(() => {
    if (isError) {
      if (error?.data?.code == 'token_not_valid') {
        setSessionExpired(true);
      }
    }
  }, [data, isError, error, dispatch]);
  return (
    <Card classes="w-full col-start-1 col-end-9 bg-white rounded-lg p-3 my-5">
      <div className="text-secondarytwo font-semibold text-left p-3 text-f18 tracking-wider">
        Purchased Companies
      </div>
      <div className="text-company font-semibold text-left px-3 py-4 uppercase text-f12 border-y border-lightGray flex justify-between">
        <span>Company Name</span>
        <span>Date of Purchase</span>
      </div>
      {isSessionExpired && <Modal modalHandle={sessionExpiredPopup}>
        <SessionExpired handleNavigate={sessionExpiredPopup} />
      </Modal>}
      {data ? (
        <>
          {data?.data?.length === 0 ? (
            <div className="flex flex-col items-center gap-5 justify-center w-1/3 mx-auto p-5 pkpp">
              <PurchaseCompany />
              <span className="text-secondary text-f14 w-2/3">
                All your Purchases will appear here
              </span>
              <Button
                onClick={() => {
                  localStorage.setItem("UpgradePlan", true);
                  navigate("/search");
                }}
                classes="border-link text-f14 text-link font-semibold border py-2 px-5 rounded"
              >
                Start Purchasing
              </Button>
            </div>
          ) : (
            <div className="max-h-80 overflow-y-auto">
              {data?.data?.map((item, index) => (
                <PurchaseList key={index} {...item} token={token} />
              ))}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="flex flex-col items-center gap-5 justify-center sm:w-1/3 mx-auto p-5">
            <PurchaseCompany />
            <span className="text-secondary text-f14 w-2/3">
              All your Purchases will appear here
            </span>
            <Button
              onClick={() => {
                localStorage.setItem("UpgradePlan", true);
                window.scrollTo(0, 0);
                navigate("/plans");
              }}
              classes="border-link text-f14 text-link font-semibold border py-2 px-5 rounded"
            >
              Start Purchasing
            </Button>
          </div>
        </>
      )}
    </Card>
  );
};
